export default __webpack_public_path__ + "static/media/letterRain.8c52d266.PNG";